// Donation service
import { apiRequest } from "./api";

// The API returns `amount` as a string (Postgres DECIMAL serializes to text).
// Coerce to a Number so callers can safely call .toFixed() / sum amounts.
const normalizeDonation = (donation) => ({
  ...donation,
  amount: Number(donation.amount),
});

export const donationService = {
  createDonation: async (name, email, amount) => {
    // Public endpoint — no auth required.
    return await apiRequest("/donations", {
      method: "POST",
      body: JSON.stringify({ name, email, amount }),
    });
  },

  createPaymentIntent: async (name, email, amount) => {
    return await apiRequest("/donations/create-payment-intent", {
      method: "POST",
      body: JSON.stringify({ name, email, amount }),
    });
  },

  confirmDonation: async (paymentIntentId) => {
    return await apiRequest("/donations/confirm", {
      method: "POST",
      body: JSON.stringify({ paymentIntentId }),
    });
  },

  getDonations: async () => {
    const donations = await apiRequest("/donations", {
      method: "GET",
      requiresAuth: true,
    });
    return Array.isArray(donations)
      ? donations.map(normalizeDonation)
      : donations;
  },

  getDonationsSummary: async () => {
    return await apiRequest("/donations/summary", {
      method: "GET",
      requiresAuth: true,
    });
  },

  getDonationsByDateRange: async (from, to) => {
    const params = new URLSearchParams();
    if (from) params.append("from", from);
    if (to) params.append("to", to);

    const queryString = params.toString();
    const endpoint = `/donations/query${queryString ? `?${queryString}` : ""}`;

    const donations = await apiRequest(endpoint, {
      method: "GET",
      requiresAuth: true,
    });
    return Array.isArray(donations)
      ? donations.map(normalizeDonation)
      : donations;
  },
};
